// Question Types
// 1. MCQs | Multiple Choice | single
// 2. boolean | true/false | single
// 3. MAQs | Multiple Answers | multiple

import { Topic } from '.'

export const stress: Topic = {
  topic: 'Stress',
  level: 'Intermediate',
  totalQuestions: 10,
  totalScore: 95,
  totalTime: 600,
  questions: [
    {
      question: 'Nos últimos meses, com que frequência você se sentiu nervoso ou estressado?',
      choices: [
        { choice: "Nunca", score: 0 },
        { choice: "Quase Nunca", score: 1 },
        { choice: "Ás vezes", score: 2 },
        { choice: "Com frequência", score: 3 },
        { choice: "Muito frequentemente", score: 4 },
      ],
      type: 'MCQs',
      correctAnswers: [
        'A syntax extension for JavaScript that allows writing HTML-like code in JavaScript',
      ],
      score: 10,
    },
    {
      question: 'Nos últimos meses, com que frequência você se sentiu incapaz de controlar as situações em sua vida?',
      choices: [
        { choice: "Nunca", score: 0 },
        { choice: "Quase Nunca", score: 1 },
        { choice: "Ás vezes", score: 2 },
        { choice: "Com frequência", score: 3 },
        { choice: "Muito frequentemente", score: 4 },
      ],
      type: 'MCQs',
      correctAnswers: [
        'A syntax extension for JavaScript that allows writing HTML-like code in JavaScript',
      ],
      score: 10,
    },
    {
      question: 'Com que frequência você se sentiu confiante em sua capacidade de lidar com problemas?',
      choices: [
        { choice: "Nunca", score: 0 },
        { choice: "Quase Nunca", score: 1 },
        { choice: "Ás vezes", score: 2 },
        { choice: "Com frequência", score: 3 },
        { choice: "Muito frequentemente", score: 4 },
      ],
      type: 'MCQs',
      correctAnswers: [
        'A syntax extension for JavaScript that allows writing HTML-like code in JavaScript',
      ],
      score: 10,
    },
    {
      question: 'Com que frequência você tem enfrentado situações que considera imprevisíveis?',
      choices: [
        { choice: "Nunca", score: 0 },
        { choice: "Quase Nunca", score: 1 },
        { choice: "Ás vezes", score: 2 },
        { choice: "Com frequência", score: 3 },
        { choice: "Muito frequentemente", score: 4 },
      ],
      type: 'MCQs',
      correctAnswers: [
        'A syntax extension for JavaScript that allows writing HTML-like code in JavaScript',
      ],
      score: 10,
    },
    {
      question: 'Com que frequência você se sentiu seguro e protegido nas últimas semanas?',
      choices: [
        { choice: "Nunca", score: 0 },
        { choice: "Quase Nunca", score: 1 },
        { choice: "Ás vezes", score: 2 },
        { choice: "Com frequência", score: 3 },
        { choice: "Muito frequentemente", score: 4 },
      ],
      type: 'MCQs',
      correctAnswers: [
        'A syntax extension for JavaScript that allows writing HTML-like code in JavaScript',
      ],
      score: 10,
    },
    {
      question: 'Com que frequência você se sentiu relaxado nas últimas semanas?',
      choices: [
        { choice: "Nunca", score: 0 },
        { choice: "Quase Nunca", score: 1 },
        { choice: "Ás vezes", score: 2 },
        { choice: "Com frequência", score: 3 },
        { choice: "Muito frequentemente", score: 4 },
      ],
      type: 'MCQs',
      correctAnswers: [
        'A syntax extension for JavaScript that allows writing HTML-like code in JavaScript',
      ],
      score: 10,
    },
    {
      question: 'Com que frequência você teve dificuldade em relaxar nas últimas semanas?',
      choices: [
        { choice: "Nunca", score: 0 },
        { choice: "Quase Nunca", score: 1 },
        { choice: "Ás vezes", score: 2 },
        { choice: "Com frequência", score: 3 },
        { choice: "Muito frequentemente", score: 4 },
      ],
      type: 'MCQs',
      correctAnswers: [
        'A syntax extension for JavaScript that allows writing HTML-like code in JavaScript',
      ],
      score: 10,
    },
    {
      question: 'Nos últimos meses, com que frequência você se sentiu irritado ou zangado?',
      choices: [
        { choice: "Nunca", score: 0 },
        { choice: "Quase Nunca", score: 1 },
        { choice: "Ás vezes", score: 2 },
        { choice: "Com frequência", score: 3 },
        { choice: "Muito frequentemente", score: 4 },
      ],
      type: 'MCQs',
      correctAnswers: [
        'A syntax extension for JavaScript that allows writing HTML-like code in JavaScript',
      ],
      score: 10,
    },
    {
      question: 'Com que frequência você se sentiu no controle de sua vida nas últimas semanas?',
      choices: [
        { choice: "Nunca", score: 0 },
        { choice: "Quase Nunca", score: 1 },
        { choice: "Ás vezes", score: 2 },
        { choice: "Com frequência", score: 3 },
        { choice: "Muito frequentemente", score: 4 },
      ],
      type: 'MCQs',
      correctAnswers: [
        'A syntax extension for JavaScript that allows writing HTML-like code in JavaScript',
      ],
      score: 10,
    },   

  ],
}
